
import * as helper from "@/helpers/helpers";
import router from '@/router/index'
import moment from "moment";
import Vue from "vue";
import jwt_decode from "jwt-decode";
const state = {
  user: null,
  authStatus: false,
  token: null,
  globalExpirationDate: null,
  acess_locations: [],
  acess_business_untis: [],
  bussines_units: [],
  locations: [],
  warehouse: [],
  all_locations: [],
  globalFeatures: [],
  pendingApprovals: 0,

};

const getters = {
  getToken: state => state.token,
  user: (state) => state.user,
  isAuth: (state) => !!state.token,
  authStatus: (state) => state.authStatus,
  globalFeatures: state => state.globalFeatures,
  globalExpirationDate: state => state.globalExpirationDate,
  pendingApprovals: state => state.pendingApprovals,
};
const actions = {
  login({ dispatch }, userData) {
    dispatch("setAuthUserData", userData);
  },
  async GET_FEATURES({ commit, state }) {
    const { user } = state;

    try {

      // Ejecutar todas las requests en paralelo usando Promise.all()
      const [features_request] = await Promise.all([
        Vue.prototype.api_Get("auth/get_user_features/" + user.user.user_id)
      ]);

      // Procesar los resultados
      const features_response = await features_request.json();

      const features = features_response[0].feature_codes;
      commit('SET_FEATURES', features);
    } catch (error) {
      console.error('Error al cargar los accesos: ', error);
    }
  },
  // NOTA: esta acción se ejecuta DENTRO del guard de navegación (router.beforeEach).
  // No debe navegar por su cuenta: el guard es el único responsable de redirigir.
  // Si navega aquí se producen dos navegaciones simultáneas -> NavigationDuplicated
  // -> el router aborta la navegación y queda la pantalla en blanco.
  autoLogin({ commit }) {
    const token = state.token
    if (token == null) {
      return
    }
    try {
      const expiration_date = jwt_decode(token);
      if (Math.floor(Date.now() / 1000) < expiration_date.exp) {
        commit('SET_EXPIRATION_DATE', expiration_date.exp)
      }
    } catch (error) {
      // Token corrupto / no decodificable: se trata como sesión inválida.
      console.error('autoLogin: token inválido', error);
    }
  },
  // Placeholder seguro para evitar "[vuex] unknown action type: auth/refreshToken".
  // No hay endpoint de refresh en el backend; si en el futuro se agrega, va aquí.
  refreshToken() {
    return Promise.resolve();
  },
  async setAuthUserData({ commit }, payload) {

    commit('SET_FEATURES', payload.user_features);
    commit("SET_TOKEN", payload.data.token);
    commit("LOGIN_USER", {
      user: payload.data,
      bussines_units: payload.dataBussines,
      locations: payload.dataLocations,
      warehouse: payload.warehouse,
      all_locations: payload.all_locations,
    });
    router.push({ name: "Home" });
  },
  logOut({ commit }) {
    commit("LOGOUT_USER");
  },

};
const mutations = {
  SET_EXPIRATION_DATE(state, date) {
    state.globalExpirationDate = date;
  },
  SET_FEATURES(state, features) {
    state.globalFeatures = features;
  },
  SET_PENDING_APPROVALS(state, count) {
    state.pendingApprovals = count;
  },
  SET_AUTH_STATUS(state, status) {

    state.authStatus = status;
  },
  LOGIN_USER(state, payload) {

    state.user = payload.user;
    state.authStatus = true;
    state.bussines_units = payload.bussines_units;
    state.all_locations = payload.all_locations
    state.locations = payload.locations;
    state.warehouse = payload.warehouse;



    // router.push({ name: "Home" });
    // location.reload();


  },
  SET_TOKEN(state, payload) {
    localStorage.setItem("token", payload);

    state.token = payload;

  },
  LOGOUT_USER(state) {

    state.user = {},
      state.authStatus = false
    state.access = [];
    state.token = null;
    state.acess_business_untis = []
    state.acess_locations = []
    state.location = [];
    state.all_locations = [];
    state.bussines_units = [];
    state.warehouse = [];
    // removeItem borra la clave; setItem("token", null) guardaba el string "null"
    // y luego jwt_decode("null") lanzaba error.
    localStorage.removeItem("token")
    // IMPORTANTE: no navegar desde la mutación. La redirección la hace el guard
    // o el componente que despacha logOut. Navegar aquí colisiona con el next()
    // del guard (NavigationDuplicated) y deja la pantalla en blanco.
  },
};


export default {
  state,
  getters,
  actions,
  mutations,

  namespaced: true,
};
